import request from '@/utils/request'
import qs from 'qs'

// ************************* 账号管理 ***************************
// 账号管理-列表
export interface IPrivateAccount {
  id: number
  accountId: string
  applePwd: string
  certId: string
  iphoneCount: number
  ipadCount: number
  itouchCount: number
  status: string
  statusId: number
  info: string
  createDate: string
  creatorName: string
  teamId: string
  accountExpireDate: string
  serverArea: string
  isAgreeNewProto: boolean
  isUse: boolean
  certStatus: string
  certExpireDate: string
}

// 账号列表
export const getAccountList = (data: any) =>
  request({
    url: '/developerAccount/list',
    method: 'get',
    params: data
  })

// 账号状态
export const getAccountStatus = () =>
  request({
    url: '/developerAccount/status',
    method: 'get'
  })

// 地区列表
export const getAccountArea = () =>
  request({
    url: '/developerAccount/area',
    method: 'get'
  })

// 账号启用/禁用
export const setAccountUsed = (data: { id: string, use: number }) =>
  request({
    url: '/developerAccount/useOrDisable',
    method: 'post',
    data: qs.stringify(data)
  })

// 重置账号
export const resetAccount = (data: { id?: number }) =>
  request({
    url: '/developerAccount/resetAccount',
    method: 'post',
    data: qs.stringify(data)
  })

// 检测账号
export const checkAccount = (data: { id?: number }) =>
  request({
    url: '/developerAccount/checkoutAccountSeal',
    method: 'post',
    data: qs.stringify(data)
  })

// 获取回签状态
export const getReSignStatus = () =>
  request({
    url: '/developerAccount/getResignSwitchStatus',
    method: 'get'
  })

// 修改回签状态
export const changeStatus = () =>
  request({
    url: '/developerAccount/changeResignSwitchStatus',
    method: 'post'
  })

// 账号新增修改
interface IAddEditAccount {
  id?: number
  area?: string
  account: string
  password: string
}
export const addEditAccount = (data: IAddEditAccount) =>
  request({
    url: `/developerAccount/addOrUpdate`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// 批量删除账号
export const deleteAccount = (data: { id: string }) =>
  request({
    url: '/developerAccount/delete',
    method: 'post',
    data: qs.stringify(data)
  })

// ************************* 签名信息 ***************************
// 签名信息-列表
export interface IPrivateSignature {
  accountId: string
  appId: number
  appName: string
  creatDate: string
  failInfo: string
  filePath: string
  id: number
  serverArea: string
  serverCode: string
  status: string
  statusId: number
  udid: string
  [key: string]: any
}
export const getSignatureList = (data: any) =>
  request({
    url: '/developerAccount/log/list',
    method: 'get',
    timeout: 10 * 60 * 1000,
    params: data
  })

// 签名状态
export const getSignatureStatus = () =>
  request({
    url: '/developerAccount/log/signStatus',
    method: 'get'
  })

// 重签
export const setSignature = (data: { id: string }) =>
  request({
    url: '/developerAccount/resign',
    method: 'post',
    data: qs.stringify(data)
  })

// 签名地区
export const getSignatureArea = () =>
  request({
    url: '/developerAccount/log/signArea',
    method: 'get'
  })

// 删除 udid 包
export const deleteUdid = (data: { clearParam: Array<{ area: string, udid: string }> }) =>
  request({
    url: '/developerAccount/clearFileByUdid',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// 使用当前开发者账号
export const changeAccount = (data: any) =>
  request({
    url: '/developerAccount/log/changeUdidAccount',
    method: 'post',
    data: qs.stringify(data)
  })

  // ************************* 用户初签列表 ***************************
  export interface InitialSigningList {
      udid: string,
      tutuid: string,
      notificationEmail: string,
      waittime: string,
      status: string,
      serverArea: string,
      accountId: string,
      id: string
      departureData:string,
      createDate:string
  }
  // 初签列表
  export const initialSigningList = (data: any) =>
  request({
    url: '/devSign/sign/list',
    method: 'get',
    timeout: 10 * 60 * 1000,
    params: data
  })
  // 签名状态
  export const signatureStatus = () =>
  request({
    url: '/devSign/sign/statusList',
    method: 'get'
  })
  // 加入黑名单
  export const joinBlacklist = (data:any) =>
  request({
    url: '/devSign/sign/addToBlacklist',
    method: 'post',
    data: qs.stringify(data)
  })
   // 移除队列
   export const removeQueue = (data:any) =>
   request({
     url: '/devSign/sign/removeFromQueue',
     method: 'post',
     data: qs.stringify(data)
   })
    // ************************* 用户回签管理 ***************************
  export interface ReturnManagement {
    udid: string,
    tutuid: string,
    notificationEmail: string,
    waittime: string,
    status: string,
    serverArea: string,
    accountId: string,
    id: string
    departureData:string,
    createDate:string
}
// 回签列表
export const ReturnManagementlist = (data: any) =>
request({
  url: '/devSign/resign/list',
  method: 'get',
  timeout: 10 * 60 * 1000,
  params: data
})
// 新增编辑接口
export const signBackAddEdit = (data:any) =>
request({
  url: '/devSign/resign/save',
  method: 'post',
  data: qs.stringify(data)
})
// 删除接口
export const deleteCheckback = (data:any) =>
request({
  url: '/devSign/resign/delete',
  method: 'post',
  data: qs.stringify(data)
})
// 可用回签账号列表
export const backToTheAccountList = (data:any) =>
  request({
    url: '/devSign/resign/listResignUsableAccount',
    method: 'get',
    params: data
  })
  // 批量签名接口
export const batchSignatureudid = (data:any) =>
request({
  url: '/devSign/resign/batchResign',
  method: 'post',
  data: qs.stringify(data)
})
  // ************************* 黑名单 ***************************
  export interface Blacklist {
    udid: string,
    tutuid: string,
    notificationEmail: string,
    waittime: string,
    status: string,
    serverArea: string,
    accountId: string,
    id: string
    departureData:string,
    createDate:string
}
// 黑名单列表
export const blacklistList = (data: any) =>
request({
  url: '/devSign/blacklist/list',
  method: 'get',
  timeout: 10 * 60 * 1000,
  params: data
})
// 新增黑名单
export const blacklistNewEditor = (data:any) =>
request({
  url: '/devSign/blacklist/save',
  method: 'post',
  data: qs.stringify(data)
})
// 删除黑名单接口
export const deleteBlacklist = (data:any) =>
request({
  url: '/devSign/blacklist/delete',
  method: 'post',
  data: qs.stringify(data)
})
  // ************************* 白名单 ***************************
  export interface Whitelist {
    udid: string,
    tutuid: string,
    notificationEmail: string,
    waittime: string,
    status: string,
    serverArea: string,
    accountId: string,
    id: string
    departureData:string,
    createDate:string
}
// 白名单列表
export const whitelistList = (data: any) =>
request({
  url: '/devSign/whitelist/list',
  method: 'get',
  timeout: 10 * 60 * 1000,
  params: data
})
// 新增白名单
export const whitelistNewEditor = (data:any) =>
request({
  url: '/devSign/whitelist/save',
  method: 'post',
  data: qs.stringify(data)
})
// 删除白名单接口
export const deleteWhitelist = (data:any) =>
request({
  url: '/devSign/whitelist/delete',
  method: 'post',
  data: qs.stringify(data)
})
 // ************************* 签名设置管理 ***************************
 export interface signatureSettings {
  udid: string,
  tutuid: string,
  notificationEmail: string,
  waittime: string,
  status: string,
  serverArea: string,
  accountId: string,
  id: string
  departureData:string,
  createDate:string
}
// 签名设置列表
export const SignatureSettingslist = (data: any) =>
request({
url: '/devSign/signconfig/list',
method: 'get',
timeout: 10 * 60 * 1000,
params: data
})
// 新增签名设置接口
export const SignatureSettingsAddEdit = (data:any) =>
request({
url: '/devSign/signconfig/save',
method: 'post',
data: qs.stringify(data)
})
// 删除签名设置接口
export const deleteSignatureSettings = (data:any) =>
request({
url: '/devSign/signconfig/delete',
method: 'post',
data: qs.stringify(data)
})
